import { execute } from 'fg-frontend/src/partialUpdate/partialUpdate';

export const eshopUserToolsRefresh = () => {
  execute({
    target: [ 'userLists', 'ramJetLayoutContext_mobile_userLists', 'ramJetLayoutContext_rwd_userLists' ],
    url: `/qf/${window.projectConfig.lang}/ramjet/include`,
  });
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/webActions/eshopUserToolsRefresh.js